<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">商家样衣审核列表</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1">
            <div class="label">星球码</div>
            <el-select
              v-model="form.xq"
              placeholder="请选择星球码"
              filterable
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in xqlist"
                :key="item.id"
                :label="item.bindCode"
                :value="item.bindCode"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item col-1">
            <div class="label">面料品名</div>
            <label
              ><input type="text" class="cg-input" v-model="form.pmname"
            /></label>
            <el-button class="publish-btn" size="small" @click="seach"
              >查询</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-table
      :data="list"
      height="500px"
      border
      style="width: 100%"
      class="custom-table"
    >
      <el-table-column
        align="center"
        prop="memberBindCode"
        label="商家星球码"
      />
      <el-table-column align="center" label="商家名称" prop="belongName" />
      <!-- 产品详情列 -->
      <el-table-column align="center" label="产品详情" min-width="100">
        <template #default="scope">
          <div class="product-detail-box">
            <!-- 封面图 coverUrl -->
            <img
              :src="getFullImgUrl(scope.row.coverUrl)"
              class="cover-img"
              alt=""
            />
            <div class="product-info" style="width: 38%">
              <el-tooltip
                :content="scope.row.title"
                placement="top-start"
                effect="dark"
              >
                <div class="product-title" :title="scope.row.title">
                  {{ scope.row.title }}
                </div>
              </el-tooltip>
              <div class="product-date">
                {{ formatYmd(scope.row.updatetime) }}
              </div>
              <el-button
                size="small"
                text
                style="background: #fff; color: red; border: 1px solid blue"
                @click="up(scope.row)"
              >
                审核查看
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="审核结果" min-width="100">
        <template #default="scope">
          <div class="options">
            <!-- 打开驳回弹窗，传当前行id -->
            <i
              class="del-icon el-icon-close"
              title="不通过"
              @click="openRejectDialog(scope.row.id)"
            ></i>
            <el-popconfirm
              title="确定通过吗?"
              confirmButtonText="确认"
              cancelButtonText="取消"
              @confirm="passUser(scope.row.id)"
            >
              <template #reference>
                <i class="pass-icon el-icon-check" title="通过"></i>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
      <template #append>
        <div
          class="load-more"
          :class="{ 'no-more': noMore }"
          v-if="list.length"
          @click="loadMore"
        >
          {{ noMore ? "没有数据了~" : "点击加载下一页" }}
        </div>
      </template>
    </el-table>
    <el-dialog
      v-model="rejectDialogVisible"
      title="审核原因:"
      width="40%"
      @close="clearRejectData"
    >
      <div style="margin-bottom: 24px; margin-top: 24px">
        <el-button
          size="small"
          :class="flag == 1 ? 'publish-btn' : ''"
          @click="
            (auditContent = '文字/图片含有夸大事实等不合规营销信息'), (flag = 1)
          "
          style="margin-left: 8px"
          >文字/图片含有夸大事实等不合规营销信息</el-button
        >
      </div>
      <div style="margin-bottom: 36px">
        <el-button
          size="small"
          :class="flag == 2 ? 'publish-btn' : ''"
          @click="
            (auditContent = '文字/图片含有色情、政治、宗教等不法信息'),
              (flag = 2)
          "
          >文字/图片含有色情、政治、宗教等不法信息</el-button
        >
      </div>
      <el-input
        v-model="auditContent"
        type="textarea"
        rows="4"
        placeholder="请输入审核不通过的原因"
        maxlength="200"
      ></el-input>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="rejectDialogVisible = false">取消</el-button>
          <el-button class="publish-btn" @click="submitReject"
            >确认不通过</el-button
          >
        </span>
      </template>
    </el-dialog>
    <el-dialog
      title="样衣审核"
      center
      width="1200px"
      height="1200px"
      v-model="showUpdate"
      @close="handleDialogClose"
    >
      <my-dialog
        :row="editRow"
        @update-success="handleUpdateSuccess"
        @cancel="showUpdate = false"
      />
    </el-dialog>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  nextTick,
  onMounted,
  getCurrentInstance,
  watch,
} from "vue";
import MyDialog from "./updata/user-product-launch.vue";
const { proxy } = getCurrentInstance();

// 分页变量
const pages = ref({ page: 1, size: 50 });
const noMore = ref(false);
const loading = ref(false);

// 驳回弹窗
const rejectDialogVisible = ref(false);
const currentAuditId = ref(null);
const auditContent = ref("");

const showUpdate = ref(false);
const form = reactive({
  pmname: "",
  xq: "",
});
const xqlist = ref([]);
const list = ref([]);
const editRow = ref(null);
const flag = ref(0);

// 缓存值
const STORAGE_KEY = "product-audit-list";

// 监听查询条件
watch([() => form.pmname, () => form.xq], () => {
  const searchParams = {
    pmname: form.pmname,
    xq: form.xq,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});
// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);
      form.xq = cache.xq ?? "";
      form.pmname = cache.pmname ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

const handleDialogClose = () => {
  editRow.value = null; // 清空数据
};
const handleUpdateSuccess = () => {
  showUpdate.value = false;
  pages.value.page = 1;
  noMore.value = false;
  list.value = [];
  getlist(); // 重新获取数据
};
const formatYmd = (time) => {
  if (!time) return "--";
  let date = new Date(time);
  if (isNaN(date.getTime())) {
    date = new Date(time.replace(/-/g, "/"));
  }
  if (isNaN(date.getTime())) return "--";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
const getFullImgUrl = (url) => {
  if (!url) return "";
  if (/^https?:\/\//.test(url)) {
    return url;
  }
  return `https://${url}`;
};
const up = (row) => {
  console.log(row, "里面是什么数据");
  // 先清空，再赋值
  editRow.value = null;
  nextTick(() => {
    editRow.value = { ...row }; // 拷贝
    showUpdate.value = true;
  });
};
// 打开驳回弹窗
const openRejectDialog = (id) => {
  flag.value = 0;
  currentAuditId.value = id;
  rejectDialogVisible.value = true;
};
// 关闭弹窗清空数据
const clearRejectData = () => {
  auditContent.value = "";
  currentAuditId.value = null;
};
// 提交驳回
const submitReject = async () => {
  if (!auditContent.value.trim()) {
    proxy.$message.warning("请填写不通过原因");
    return;
  }
  const sendata = {
    id: currentAuditId.value,
    flag: 0,
    auditContent: auditContent.value,
  };
  const res = await proxy.$api.Operation.ProductauditList.pass(sendata);
  if (res.data.code == "200") {
    proxy.$message.success("驳回成功");
    rejectDialogVisible.value = false;
    clearRejectData();
    pages.value.page = 1;
    noMore.value = false;
    list.value = [];
    getlist();
  } else {
    proxy.$message.error(res.data.msg);
  }
};
// 通过审核
const passUser = async (id) => {
  const sendata = {
    id: id,
    flag: 1,
  };
  const res = await proxy.$api.Operation.ProductauditList.pass(sendata);
  if (res.data.code == "200") {
    proxy.$message.success("审核通过");
    pages.value.page = 1;
    noMore.value = false;
    list.value = [];
    getlist();
  } else {
    proxy.$message.error(res.data.msg);
  }
};
const seach = () => {
  pages.value.page = 1;
  noMore.value = false;
  list.value = [];
  getlist();
};
const loadMore = async () => {
  await getlist(true);
};
const getlist = async (isLoadMore = false) => {
  if (noMore.value || loading.value) return;
  const sendata = {
    currentPage: pages.value.page,
    pageSize: pages.value.size,
    memberBindCode: form.xq,
    name: form.pmname,
  };
  try {
    loading.value = true;
    const res = await proxy.$api.Operation.ProductauditList.get(sendata);
    if (res.data.code == "200") {
      const currentData = Array.isArray(res.data.data.list)
        ? res.data.data.list
        : [];
      if (pages.value.page === 1) {
        list.value = currentData;
      } else {
        list.value = [...list.value, ...currentData];
      }
      const total = res.data.data.total;
      noMore.value =
        total != null
          ? list.value.length >= total
          : currentData.length < pages.value.size;
      pages.value.page += 1;
    } else if (!isLoadMore) {
      console.log("获取分类列表失败：", res.data?.msg || "接口返回异常");
    }
  } catch (e) {
    if (!isLoadMore) {
      console.log("获取分类列表失败");
    }
  } finally {
    loading.value = false;
  }
};
const xqm = async () => {
  const sendata = {
    nickName: "",
    version: "",
  };
  const res = await proxy.$api.System.MemberVersion.get(sendata);
  if (res.data.code == 200) {
    xqlist.value = res.data.data.list.map((item) => ({
      bindCode: item.bindCode,
    }));
  } else {
    proxy.$message.error("网络错误");
    xqlist.value = [];
  }
};

onMounted(() => {
  xqm();
  loadSearchCache();
  getlist();
});
</script>

<style lang="scss" scoped>
@import "./product-audit-list.scss";
.panel-title {
  color: #999;
}
:deep(.el-dialog__header) {
  padding-bottom: 0px;
}
// 产品详情样式
.product-detail-box {
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: center;
  .cover-img {
    width: 70px;
    height: 90px;
    object-fit: cover;
    border: 1px solid #eee;
  }
  .product-info {
    text-align: left;
    .product-title {
      font-size: 16px;
      margin-bottom: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 160px;
      cursor: pointer;
    }
    .product-date {
      font-size: 14px;
      color: #666;
      margin-bottom: 6px;
    }
  }
}
// 大图预览弹窗
.img-wrap {
  text-align: center;
  .preview-img {
    max-width: 100%;
    max-height: 600px;
  }
}
// icon图标
.del-icon {
  font-size: 22px;
  cursor: pointer;
  color: red;
  margin-right: 16px;
}
.pass-icon {
  font-size: 22px;
  cursor: pointer;
  color: green;
}
:deep(.el-dialog) {
  margin-top: 0vh !important;
}
:deep(.el-dialog--center .el-dialog__body) {
  height: 850px !important;
}
.load-more {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #666;
  cursor: pointer;
  &:hover {
    background: #e9ecef;
  }
  &.no-more {
    color: #999;
    cursor: default;
  }
}
</style>
<style>
.publish-btn {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333 !important;
  font-weight: 500;
}
.publish-btn {
  background-color: #ff9900;
}
</style>
